import { render, staticRenderFns } from "./CustomAssess.vue?vue&type=template&id=4eba1fdf&scoped=true&"
import script from "./CustomAssess.vue?vue&type=script&lang=js&"
export * from "./CustomAssess.vue?vue&type=script&lang=js&"
import style0 from "./CustomAssess.vue?vue&type=style&index=0&id=4eba1fdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba1fdf",
  null
  
)

export default component.exports